import React from "react";
import { Type } from "lucide-react";

interface TextOverlay {
  id: string;
  text: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;
  position: { x: number; y: number };
  size?: { width: number; height: number };
  visible: boolean;
  isBold?: boolean;
  isItalic?: boolean;
  isUnderline?: boolean;
  padding?: number;
  rotation?: number; // Rotation in degrees
  opacity?: number; // Opacity (0-1)
  fontFamily?: string;
}

interface TextOverlayControlsProps {
  textOverlays: TextOverlay[];
  onTextOverlaysChange: (textOverlays: TextOverlay[]) => void;
  selectedTextOverlayId?: string;
  onTextOverlaySelect?: (textOverlayId: string) => void;
  showAddButton?: boolean;
  showRemoveButton?: boolean;
  showFontSizeControl?: boolean;
  showColorControls?: boolean;
  showBackgroundColorControl?: boolean;
  isPreview?: boolean;
}

export const TextOverlayControls: React.FC<TextOverlayControlsProps> = ({
  textOverlays,
  onTextOverlaysChange,
  onTextOverlaySelect,
  showAddButton = true,
  isPreview = false,
}) => {
  const addTextOverlay = () => {
    const newOverlay: TextOverlay = {
      id: `text-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      text: "New Text",
      fontSize: 24,
      fontColor: "#ffffff",
      backgroundColor: "#000000",
      position: { x: 50, y: 50 },
      visible: true,
      fontFamily: "Arial",
      rotation: 0,
      opacity: 1.0,
    };
    onTextOverlaysChange([...textOverlays, newOverlay]);
    onTextOverlaySelect?.(newOverlay.id);
  };

  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between mb-2 flex-column gap-3">
        <h6 className="text-uppercase d-flex">Text</h6>
        {showAddButton && !isPreview && (
          <button
            type="button"
            onClick={addTextOverlay}
            className="btn btn-outline-primary border w-100"
          >
            <Type className="me-2" />
            Add a text box
          </button>
        )}
      </div>
    </div>
  );
};

export default TextOverlayControls;
